module.exports = __webpack_public_path__ + "img/cube.a97f0bc2.svg";